import React from 'react';
import { useSurebet } from '../context/SurebetContext';
import { useTranslation } from '../../i18n/hooks';
import { BOOKMAKERS } from '../constants/surebetTypes';

const BOOKMAKER_DISPLAY_KEYS = {
  efbet: 'efbet',
  bg8888: 'bg8888',
  bg_8888: 'bg8888',
};

/**
 * NearArbInfo - configured bookmakers and server threshold for the Near-arb tab.
 * Replaces the bookmaker FilterPanel on this tab.
 * Names come only from the near-arb response, not from the event cards.
 */
const displayBookmakerName = (id) => {
  const key = BOOKMAKER_DISPLAY_KEYS[id] || id;
  return BOOKMAKERS[key]?.name || id;
};

const NearArbInfo = () => {
  const { t } = useTranslation();
  const { nearArbMeta, loading, error } = useSurebet();
  const bookmakers = Array.isArray(nearArbMeta?.bookmakers) ? nearArbMeta.bookmakers : [];
  const names = bookmakers.map(displayBookmakerName).join(', ');
  const minMargin = nearArbMeta?.minMargin;
  const hasThreshold = minMargin !== null && minMargin !== undefined && !Number.isNaN(minMargin);
  const minMarginLabel = hasThreshold ? minMargin : '—';

  if (loading && !names && !hasThreshold) {
    return (
      <p className="dashboard-product-info near-arb-info">
        {t('surebets.list.loading')}
      </p>
    );
  }

  if (error && !names && !hasThreshold) {
    const message = error === 'ULTIMATE_REQUIRED'
      ? t('nearArb.upgradeRequired')
      : error === 'NEAR_ARB_UNAVAILABLE'
        ? t('nearArb.unavailable')
        : error;
    return (
      <p className="dashboard-product-info near-arb-info">
        {message}
      </p>
    );
  }

  return (
    <p className="dashboard-product-info near-arb-info">
      {t('nearArb.infoLine', {
        bookmakers: names || '—',
        minMargin: minMarginLabel,
      })}
    </p>
  );
};

export default NearArbInfo;
